import Imgix from './Imgix';

export default class DropAHint {
    constructor() {
        this.imgixInstance = new Imgix(); // register new Imgix instance

        this.buttons = document.querySelectorAll('[data-module="share-modal"]');
        this.init();
    }

    init() {
        this.buttons.forEach(button => {
            const target = button.nextElementSibling;

            if (target && target.dataset.target === "share-modal") {
                button.addEventListener('click', (e) => this.openDialog(e, target));

                const closeButton = target.querySelector('.drop-a-hint__close');
                const copyButton = target.querySelector('.drop-a-hint__link--copy');
                const overlay = target;

                if (closeButton) {
                    closeButton.addEventListener('click', () => this.closeDialog(target));
                }

                if (overlay) {
                    overlay.addEventListener('click', (e) => {
                        if (e.target === overlay) this.closeDialog(target);
                    });
                }

                if (copyButton) {
                    copyButton.addEventListener('click', () => this.copyLink(copyButton));
                }
            }
        });
    }

    openDialog(e, target) {
        e.preventDefault();
        document.body.classList.add('dropping-a-hint');
        target.showModal();
        this.imgixInstance.process(target);
    }

    closeDialog(target) {
        document.body.classList.remove('dropping-a-hint');
        target.close();
    }

    copyLink(button) {
        navigator.clipboard.writeText(window.location.href).then(() => {
            button.classList.add('copied');
            setTimeout(() => button.classList.remove('copied'), 1000);
        });
    }
}
